import { CommonHeader } from "@bcc/components/common-header";
import { LabelTemplates } from "@bcc/components/labels/label-templates";
import { RecentLabels } from "@bcc/components/labels/recent-labels";
import { Button } from "@bcc/components/ui/button";
import { usePermissions } from "@bcc/hooks/use-permissions";
import { Plus, Printer } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setLabelsViewNewLabelButtonTestId, setLabelsViewPrintQueueButtonTestId, setLabelsViewTestId } from "./labels-view.utils";

interface TemplateData {
  id: number;
  name: string;
  description: string;
  icon: string;
  uses: number;
}

interface RecentLabelData {
  id: number;
  product: string;
  template: string;
  quantity: number;
  date: string;
  status: "printed" | "ready";
}

interface LabelsViewProps {
  templatesData: TemplateData[];
  recentLabelsData: RecentLabelData[];
  testId?: string;
}

export function LabelsView({ templatesData, recentLabelsData, testId }: Readonly<LabelsViewProps>) {
  const { t } = useTranslation();
  const { canCreate } = usePermissions();

  return (
    <div data-testid={testId ?? setLabelsViewTestId("container")} className="space-y-6">
      <CommonHeader
        title={t("views.labels.title")}
        description={t("views.labels.description")}
        actions={
          <>
            <Button testId={setLabelsViewPrintQueueButtonTestId()} variant="outline">
              <Printer className="mr-2 h-4 w-4" />
              {t("views.labels.printQueue")}
            </Button>
            {canCreate("labels") ? (
              <Button testId={setLabelsViewNewLabelButtonTestId()} className="bg-primary text-primary-foreground hover:bg-primary/90">
                <Plus className="mr-2 h-4 w-4" />
                {t("views.labels.newLabel")}
              </Button>
            ) : null}
          </>
        }
      />
      <LabelTemplates data={templatesData} />
      <RecentLabels data={recentLabelsData} />
    </div>
  );
}
